import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import icp from '../../images/icp.jpg'
import './foot.css'

function Foot () {
  return (
    <div className="footer">
      <div>
        <Link to="/">首页</Link>&emsp;|&emsp;
        <Link to="/operation">运营中心</Link>&emsp;|&emsp;
        <Link to="/join">合作及洽谈</Link>&emsp;|&emsp;
        <Link to="/contact">联系我们</Link>&emsp;|&emsp;
        <a target="_blank" rel="noreferrer" href="/appdowns">应用下载</a>&emsp;|&emsp;
        <Link to="/about">关于我们</Link>
      </div>
      <div>
        <span>粤公网安备 44060602001650号</span>&ensp;|&ensp;
        <a target="_self" rel="noreferrer" href="https://beian.miit.gov.cn/">粤ICP备14093582号</a>&ensp;|&ensp;
        <a target="_blank" rel="noreferrer" href={icp}>增值电信业务经营许可证:粤B2-20160109</a>
      </div>
      <div>
        <span>2017 All Rights Reserved. 深圳市纵购电子商务有限公司</span>&ensp;|&ensp;
        <a href="//beian.miit.gov.cn" rel="noreferrer" target="_blank">工信部官网</a>&ensp;|&ensp;
        <a target="_blank" rel="noreferrer" href="https://static.ourchoice.cn/h5/public/regulation.html?app=1">平台规则</a>&ensp;|&ensp;
        <a target="_blank" rel="noreferrer" href="https://static.ourchoice.cn/h5/public/agreement.html?app=1">用户协议</a>&ensp;|&ensp;
        <a target="_blank" rel="noreferrer" href="https://static.ourchoice.cn/h5/public/privacy.html?app=1">隐私协议</a>&ensp;|&ensp;
        <a target="_blank" rel="noreferrer" href="https://www.yos168.com/images/yos168.png">营业执照</a>&ensp;|&ensp;
        <a target="_blank" rel="noreferrer" href="https://static.ourchoice.cn/h5/public/rules.html?app=1">违规订单处理行为规则</a>
      </div>
      <p>Copyright © 2019-2021 ourchoice.cn, All rights reserved.</p>
    </div>
  )
}

export default withRouter(Foot)
